<template>
  <div class="ClaimFlow">
    <div class="main">
        <p class="title2">用户在使用WiFi万能钥匙连接网络的过程中，发现银行账户资金(用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名制账户中的资产)遭受损失，应立即采取以下措施:</p>
        <p class="label"><span class="circle"></span>1.保全证据</p>
        <p class="text">发现损失后，立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与对方的聊天记录以及所下载软件，以免导致相关证据无法保全；</p>
        <p class="label"><span class="circle"></span>2.报案</p>
        <p class="text">在保全证据后，立即拨打保险公司电话进行报案，并于10个自然日内前往用户住所地或经常居住地有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；</p>
        <p class="text highlight">众安保险客服电话:400-999-9595</p>
        <p class="text highlight">(7X24小时统一客服热线)</p>
        <p class="label"><span class="circle"></span>3.准备索赔资料</p>
        <p class="text">用户应自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，根据WiFi万能钥匙官网或者手机客户端索赔界面的提示准备索赔资料。并听从工作人员的操作指导，配合提供相关损失的证明文件，以便有效核实被盗情况。</p>
        <p class="text">若保险公司或WiFi万能钥匙的工作人员联系用户时，自首次尝试联系用户起72小时内无法与用户取得联系，将视用户自动放弃索赔。</p>
        <p class="label"><span class="circle"></span>4.提交索赔资料</p>
        <p class="text">用户应自使用WiFI万能钥匙遭受直接经济损失之日起15个自然日内，根据保险公司工作人员的指示，将索赔资料快递至以下地址(不接受快递到付)，并确保其所提交资料的真实性。配合提供相关损失的证明文件，以便有效核实被盗情况。</p>
        <p class="text highlight">
            收件人:WiFi万能钥匙用户安全理赔项目组<br>
            快递联系电话:400-035-8000<br>
            寄送地址:上海市浦东新区张衡路666弄1号楼7楼
        </p>
        <p class="label"><span class="circle"></span>5.理赔结果</p>
        <p class="text last">保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元(含3000元)以下的案件由保险公司在确认最终理赔结果后的5个工作日内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClaimFlow',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
html { font-family: "Microsoft Yahei",arial,helvetica,sans-serif; -webkit-text-size-adjust:none; word-break : break-word;}
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, a, code, em, img, q, small, strong, dd, dl, dt, li, ol, ul, fieldset, form, label, table, tbody, tr, th, td, input { margin: 0; padding: 0; outline:0;}

body{background-color: #f3f3f3;height: 100%;}
a[href$="1257113351"]{width: 0;height:0;position: absolute;top: -1000px;left:-1000px;}
.hide{display: none;}
.f12{font-size: 12px;}
.f14{font-size: 14px;}
.c3{color: #333;}
.fb{font-weight: bold;}
.t_c{text-align: center;}

.main{display: block; position: relative;color: #666666;padding:0 6% 36px 6%;}
.title{font-size: 16px; color: #0285f0;  line-height: 20px}
.title2{font-size: 12px; color: #666666; font-weight: bold;  line-height: 20px;margin:16px 0; }
.title_bold{font-size: 12px; color: #333333; font-weight: bold;  line-height: 22px;}
.label{font-size: 12px;color:#333333;font-weight: bold;}
.notes{margin-top: 17px;margin-bottom: 2px;}
.text{font-size: 12px;color: #666666;line-height: 24px; margin-bottom: 3px;}
.highlight{color: #0285f0;}
.label{line-height: 25px;}
.text{line-height: 20px;padding-bottom: 10px;}
.label,.text{border-left: #cccccc 1px dotted;  padding-left: 24px;}
.last{border:none;}
.circle {
    display: block;
    width: 8px;
    height: 8px;
    background: #0285f0;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    left: 5%;
    margin-top: 9px;
}
</style>



// WEBPACK FOOTER //
// ClaimFlow.vue?27b7f07e